module.exports = __webpack_public_path__ + "media/assets/image-3c3202d92c0ee92105c892a1e22ac088763c7ce35b1ba3f9383b110967fd0dd2.svg";